import { CheckCircleIcon as PhosphorCheckCircleIcon } from "@phosphor-icons/react/dist/ssr/CheckCircle";

import { createAppIcon } from "@/components/createAppIcon";

export const SuccessIcon = /* @__PURE__ */ createAppIcon(PhosphorCheckCircleIcon);
